import axiosService from "./axios-service";

export const getAdminNotifications = async (category) => {
  const query = category ? `?category=${category}` : "";
  return axiosService.get(`/sales/incentive/admin/fetch_notification${query}`);
};

export const getUserNotifications = async (category) => {
  const query = category ? `?category=${category}` : "";
  return axiosService.get(`/sales/incentive/fetch_notification${query}`);
};

export const getNotification = async (id) => {
  return axiosService.get(`/sales/incentive/admin/fetch_notification?id=${id}`);
};

export const addNotification = async (data) => {
  return axiosService.post(`/sales/incentive/admin/upsert_notification`, data);
};

export const disableNotification = async (id) => {
  return axiosService.get(
    `/sales/incentive/admin/delete_notification?id=${id}`
  );
};
